import groq from 'groq';

import { ASSET } from '../common';

export const INGREDIENTS = groq`
  _type,
  title,
  "mitopureIngredient": mitopureIngredientRef-> {
    title,
    description,
    impact,
    image { ${ASSET} },
    moleculeImage { ${ASSET} }
  },
  "activeIngredients": activeIngredientRefs[]-> {
    title,
    description,
    impact,
    image { ${ASSET} },
    moleculeImage { ${ASSET} }
  },
  "informationPanel": ^.^.informationPanel {
    alt,
    "url": asset -> url,
  },
  productFacts
`;

export const KEY_INGREDIENTS_BLOCK = groq`
  _type == 'ingredients' => @-> {
    ${INGREDIENTS}
  }
`;
